export const TOP_SHAREHOLDERS = 1;
export const PRODUCT_ONE = 'Standard';
export const PRODUCT_TWO = 'Premium';
export const PRODUCT_THREE = 'Professional';
